import React from 'react';

export default function Image({
    src,
    srcSet,
    alt,
    sources = [],
    className = "",
    width,
    height,
    loading = "lazy"
}) {
    return (
        <>
            {sources?.length > 0 ?
                (
                    <picture>
                        {sources?.map((source, sourceIndex) => (
                            <source
                                key={sourceIndex}
                                srcSet={Object.entries(source?.set || {}).map(([key, value]) => `${value} ${key}`).join(', ')}
                                media={source?.media}
                            />
                        ))}
                        <img
                            className={`${className} img-fluid`}
                            {...{ src, srcSet, alt, width, height, loading }}
                        />
                    </picture>
                ) : (
                    <img
                        className={`${className} img-fluid`}
                        {...{ src, srcSet, alt, width, height, loading }}
                    />
                )
            }
        </>
    );
}
